module.exports = __webpack_public_path__ + "static/index/img/baikal-707.4c7e8ced.jpg";